import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';

import { environment } from '../environments/environment';
import { AuthGuardService } from './auth/auth-guard.service';

const routes: Routes = [
  { path: 'callback', loadChildren: () => import('./auth/auth-callback/auth-callback.module').then(m => m.AuthCallbackPageModule) },
  { path: 'endsession', loadChildren: () => import('./auth/end-session/end-session.module').then(m => m.EndSessionPageModule) },
  { path: 'serverconfig', loadChildren: () => import('./config-selector/config-selector.module').then(m=>m.ConfigSelectorPageModule)},
  {
    path: 'situation',
    data: { breadcrumb: 'Situation' },
    canActivate: [AuthGuardService],
    loadChildren: () => import('./situation/situation.module').then(m => m.SituationPageModule)
  },
  {
    path: 'mission',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./mission/mission.module').then(m => m.MissionPageModule)
  },
  {
    path: 'image-modal',
    loadChildren: () => import('./image-modal/image-modal.module').then(m => m.ImageModalPageModule)
  },
  {
    path: 'video-modal',
    loadChildren: () => import('./video-modal/video-modal.module').then(m => m.VideoModalPageModule)
  },
  {
    path: '',
    redirectTo: 'situation',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    AkitaNgRouterStoreModule,
    environment.production ? [] : AkitaNgDevtools.forRoot(),
    RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always', relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
